import { render, staticRenderFns } from "./simplifyCarFee.vue?vue&type=template&id=6c011caa&scoped=true"
import script from "./simplifyCarFee.vue?vue&type=script&lang=js"
export * from "./simplifyCarFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyCarFee.vue?vue&type=style&index=0&id=6c011caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c011caa",
  null
  
)

export default component.exports